export default __webpack_public_path__ + "static/proxima-nova-700-i-20429698239a621430d9380c340c854a.woff2";